import { useObservable } from './useObservable';
/**
 * Подписка на стор, чтобы актуализировать локальную копию
 */
export function useConnectStore(store, setState) {
    useObservable(store.state$, setState);
}
//# sourceMappingURL=useConnectStore.js.map